module.exports = __webpack_public_path__ + "assets/b19f440bd4026bf4c59207484d18b421.ttf";